import Loandetailswriteoffview from "../../../jsx/components/Dashboard/LoanDetails/loandetailswriteoffview";

const LoandetailswriteoffviewWrapper = () => {
  return <Loandetailswriteoffview />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.collections,
];
export default constore(LoandetailswriteoffviewWrapper);
